import { useReveal } from '../hooks/useReveal';

/**
 * Fades and lifts its children in once, the moment they scroll into view.
 * See `.reveal` (styles/components.css) for the actual transition and its
 * `prefers-reduced-motion` override.
 */
export default function Reveal({ as: Tag = 'div', className = '', delay, children, ...rest }) {
  const [ref, visible] = useReveal();
  return (
    <Tag
      ref={ref}
      className={`reveal${visible ? ' is-in' : ''}${className ? ` ${className}` : ''}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
      {...rest}
    >
      {children}
    </Tag>
  );
}
